module.exports = __webpack_public_path__ + "img/PL10204.352be5b2.png";